"use client";
import { FC } from "react";
import FaqItem from "@/components/common/FAQItem";
import { FAQS } from "@/ui/data";

type Props = {
	strapiData: any;
};

const Faq: FC<Props> = ({ strapiData }) => {
	const strapiFaqs = (strapiData?.faqs?.data ?? [])
		.slice()
		.sort((a: any, b: any) => a.id - b.id)
		.map((el: any) => el.attributes);
	const prettyData = strapiFaqs.length ? strapiFaqs : FAQS;
	return (
		<div className='w-full h-[100%] bg-faqScreenGradient px-[80px] max-desktop:px-[40px] mt-[-1px] max-tablet:px-[16px]'>
			<p className='font-bold pt-[149px] max-desktop:pt-[64px] max-tablet:pt-[47px] text-[72px] max-desktop:text-[40px] max-tablet:text-center mb-[18px]'>
				{`FAQ’s`}
			</p>
			<div className='flex flex-col gap-[7px] max-desktop:gap-[7px]'>
				{prettyData.map((el: any, index: number) => (
					<FaqItem key={index} title={el.title} text={el.text} />
				))}
			</div>
		</div>
	);
};

export default Faq;
